import ReactDOM from 'react-dom/client';
import App from './App';
import '@osttra/ds/dist/styles/osttra-ds.min.css';
import ErrorPage from './ErrorPage';
import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
} from 'react-router-dom';
import { getEnvType } from './InnerFunctions';
import EnvironmentContext from './context/EnvironmentContext';
import CaptureDetails from './components/Pages/CaptureDetails/CaptureDetails';

const hostname = window.location.hostname;
const currentEnv = getEnvType(hostname);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const errorMessage =
  "Seems you don't have access to this app or user mapping is missing," +
  ' try refreshing user screen or contact your admin';
root.render(
  <EnvironmentContext.Provider value={currentEnv}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/redirectionError" element={<ErrorPage errorMsgScreen={errorMessage} responseCode={'409'} />} />
        <Route path="/capture-email" element={<CaptureDetails />} />
      </Routes>
    </BrowserRouter>
  </EnvironmentContext.Provider>
);
